module.exports = __webpack_public_path__ + "img/sweden-flag-round-small.b452d5de.png";